<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3>Total students: {{classInfo && classInfo.studentIds && classInfo.studentIds.length ?
                        classInfo.studentIds.length : 0}}</h3>
                </v-card-title>

                <v-list v-if="students && students.length" two-line>
                    <template v-for="(student, index) in students">
                        <v-list-tile
                                :key="student.id + student.getFullName()"
                                avatar
                                ripple
                                @click="navigateToStudent(student.id)"
                        >
                            <v-list-tile-avatar>
                                <v-icon>face</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ student.getFullName() }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                                v-if="index + 1 < students.length"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-list>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {Class} from "../state/models/Class";

    export default {
        name: "ClassDetail",
        data: function() {
            return {
                id: +this.$router.currentRoute.params['id'],
                classInfo: new Class(),
                students: []
            };
        },
        methods: {
            navigateToStudent(id) {
                this.$router.push({
                    name: 'student',
                    params: {id: id}
                })
            }
        },
        mounted() {
            this.$store.dispatch('getClasses', {ids: [this.id]})
                .then((cList) => {
                    if (!cList || !cList.length) {
                        return Promise.reject('The class wasn\'t found');
                    }
                    this.classInfo = cList[0];

                    this.$store.commit('setToolbarOptions', {
                        title: 'Class',
                        subTitle: this.classInfo.name,
                        hideSearch: false,
                        backButtonRoute: {name: 'classes'}
                    });
                    return Promise.resolve(cList[0]);
                })
                .then((c) => {
                    if (!c || !c.studentIds || !c.studentIds.length) {
                        this.students = [];
                        return Promise.resolve([]);
                    }
                    this.$store.dispatch('getStudents', {ids: c.studentIds})
                        .then((sList) => {
                            if (!sList || !sList.length) {
                                return Promise.reject('Unable to retrieve student information');
                            }
                            this.students = sList;
                            return Promise.resolve(sList);
                        });
                });
        }
    }
</script>

<style scoped>

</style>
